import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import Lottie from 'lottie-web';
import { QUOTES } from './constants';

@Component({
  selector: 'app-loader',
  template: `
    <div class="container-spinner">
      <div id="animation" class="loader__animation"></div>
      <div *ngIf="randomQuote" class="loader__quote">{{ randomQuote }}</div>
    </div>
  `,
  styleUrls: ['./loader.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LoaderComponent implements OnInit {
  public randomQuote = '';

  constructor() {}

  ngOnInit() {
    this.generateRandomQuote();
    const animationData = '/images/animations/loader.json';

    Lottie.loadAnimation({
      container: document.getElementById('animation'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: animationData,
    });
  }

  private generateRandomQuote() {
    const { quote } = QUOTES[Math.floor(Math.random() * QUOTES.length)];
    this.randomQuote = quote;
  }
}
